import { FormControl } from '@angular/forms';

export function secureValidator(control: FormControl): any {
  // tslint:disable-next-line: max-line-length
  const regex = /\b(char|nchar|varchar|nvarchar|alter|begin|cast|create|cursor|declare|delete|drop|end|exec|execute|fetch|insert|kill|open|select|sys|sysobjects|syscolumns|table|update)\b/i;
  if (control.value) {
    if (control.value.match(/[^\x20-\x7E]+/g)) {
      return { secure: true };
    }
    // else if (control.value.match(regex)) {
    //   return {secure: true};
    // }
  }

  return null;
}
